module.exports = {"Centrifugal":"Centrifugal","Diecasting":"Diecasting","Investment":"Investment","Permanent Mold":"Permanent Mold","Semi Permanent Mold":"Semi Permanent Mold","Plaster":"Plaster","Pouring":"Pouring","Sand":"Sand","Semi-Solid":"Semi-Solid","Shell Mold":"Shell Mold","Squeeze":"Squeeze","Squeeze/Semi-Solid":"Squeeze/Semi-Solid","V-Process":"V-Process","Vacuum Melt Capabilities":"Vacuum Melt Capabilities","Investment Casting Tooling":"Investment Casting Tooling"}


//////////////////
// WEBPACK FOOTER
// ./src/config/castingProcess.json
// module id = 5680
// module chunks = 1